import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import ConfigureFiltering from './configure-filtering'

const selector = formValueSelector('widget')

const FilteringWithActions = connect((state, props) => ({
  enableBlastFiltering: selector(state, 'enableBlastFiltering'),
  widgetId: props.widgetId
}))(ConfigureFiltering)

export default FilteringWithActions



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-filtering/container.js